import axios from "../general/HttpClient";

import * as React from "react";

export function ListClients() {
    return axios.get(`/api/clients/list`);
}

export function GetClients(organizationId: string) {
    return axios.get(`/api/clients/`, { params: { organizationId } });
}

export function GetClient(id) {
    return axios.get(`/api/clients/${id}`);
}

export function CreateClient(data) {
    return axios.post("/api/Clients", data);
}

export function CreateClientRedirectUri(id, redirectUri) {
    return axios.post(`/api/Clients/${id}/RedirectUris?redirectUri=${redirectUri}`, {});
}

export function RemoveClientRedirectUri(id, redirectUri) {
    return axios.delete(`/api/Clients/${id}/RedirectUris?redirectUri=${redirectUri}`);
}

export function CreateClientPostLogoutRedirectUri(id, postLogoutRedirectUri) {
    return axios.post(`/api/Clients/${id}/PostLogoutRedirectUris?postLogoutRedirectUri=${postLogoutRedirectUri}`, {});
}

export function RemoveClientPostLogoutRedirectUri(id, postLogoutRedirectUri) {
    return axios.delete(`/api/Clients/${id}/PostLogoutRedirectUris?postLogoutRedirectUri=${postLogoutRedirectUri}`);
}

export function UpdateClient(data) {
    return axios.put(`/api/Clients/${data.id}`, data);
}

export function DeleteClient(id) {
    return axios.delete(`/api/Clients/${id}`);
}

export function UpdateClientProperties(id, key, value) {
    return axios.put(`/api/Clients/${id}/Properties`, { key, value });
}

export function CreateClientSecret(id) {
    return axios.post(`/api/Clients/${id}/Secrets`);
}

export function DeleteClientSecret(id, secretId) {
    return axios.delete(`/api/Clients/${id}/Secrets/${secretId}`);
}

export function useClient(id) {
    const [client, setClient] = React.useState({} as any);

    let refresh = () => {
        GetClient(id).then((response) => {
            setClient(response.data);
        });
    };

    React.useEffect(refresh, []);

    return [client, refresh];
}
